import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, CifraCargando, Group } from "@/components/ui";

/**
 * Encabezado de la página · breadcrumbs + acciones (Volver / Nueva área).
 * El botón "Nueva área" oculta el CTA mientras el formulario está abierto
 * para evitar dobles formularios apilados.
 */
export function AreasHeader({
  total,
  modoCrear,
  onIniciarCrear,
}: {
  /** undefined en la primera carga (sin caché) · se pinta una barra en vez de «0». */
  total: number | undefined;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Áreas"
      description={<><CifraCargando valor={total} /> áreas del banco · se asignan a usuarios y enrutan las solicitudes al flujo de autorización correspondiente.</>}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nueva área
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
